import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Link } from 'react-router-dom';
import { isNil } from 'lodash';
import { Button, Drawer, DrawerHeader, DrawerContent, ListItem, ListItemText, Typography, Theme } from 'rmwc';
import { RightDrawer, DrawerSubHeader, DrawerFooter, DrawerFlex } from '../components/ModuleDrawer/RightDrawer';
import { Text } from '../components/Text';
import ScheduleAdvisor from './ReviewWithHarbor/ScheduleAdvisor';
import ReviewWithHarbor from './ReviewWithHarbor/ReviewWithHarbor';
import { wlPath } from '../helpers/whitelabel';

export default class ReviewYourPlan extends Component {
  state = {
    open: false,
    animating: false,
  };

  componentDidMount() {
    this.setState({ animating: true });
    setTimeout(() => {
      this.setState({ open: true });
    }, 200);
    setTimeout(() => {
      this.setState({ animating: false });
    }, 500);
  }

  _onClose = () => {
    const { match } = this.props;
    this.setState({ open: false });

    // find path to return to:
    let returnUrl = wlPath(`/${match.url.split('/')[2]}`);

    setTimeout(() => {
      this.props.history.push(returnUrl);
    }, 200);
  };

  render() {
    const { match, history } = this.props;

    const pageProps = {
      onClose: this._onClose,
      rootUrl: match.url,
      match,
      history,
    };

    return (
      <div>
        <RightDrawer
          className="hrbr-review-plan"
          open={this.state.open}
          onClose={this._onClose}
          onOpen={this.fetchData}
          temporary
        >
          <DrawerFlex className="hrbr-drawer-scroll">
            <DrawerHeader theme="primary-bg on-primary">
              <Typography use="headline5">Review Your Plan</Typography>
            </DrawerHeader>

            <DrawerSubHeader>Review with a Harbor Advisor</DrawerSubHeader>

            <Route exact={true} path={match.url} render={() => <ReviewWithHarbor {...pageProps} />} />
            <Route
              exact={true}
              path={`${match.url}/schedule`}
              render={() => <ScheduleAdvisor withHarbor {...pageProps} />}
            />
          </DrawerFlex>
        </RightDrawer>
      </div>
    );
  }
}
